import { createContext, useContext, useEffect, useState } from "react";
import React from 'react'
import { auth, db } from "../config/Firebase";
import { getDocs, collection, runTransaction, doc, addDoc } from "firebase/firestore";
import { signOut } from 'firebase/auth'
import axios from "axios";
const FirebaseContext = createContext();

const FirebaseAppProvider = ({ children }) => {

    const name = "Isha"

    const topicsCollectionsRef = collection(db, 'Topics');
    const usersCollectionRef = collection(db, "Users");

    const [topics, setTopics] = useState([]);
    const [usersData, setUsersData] = useState([]);

    const [alertText, setAlertText] = useState("");
    const [alertType, setAlertType] = useState("");
    const [showAlert, setShowAlert] = useState(false);



    const [user, setUser] = useState({
        ip: '',
        topicId: '',
        topicName: ''
    })


    useEffect(() => {
        getAllTopicsData();
        getIpAddressOFUser();
        getAllUsersData();
    }, [])

    const logout = async () => {
        try {
            await signOut(auth);

        }
        catch (err) {
            console.log(err)

        }
    }


    // *******************getAllTopicsData***********************
    const getAllTopicsData = async () => {
        try {
            const data = await getDocs(topicsCollectionsRef);
            const filteredData = data.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }))

            setTopics(filteredData)
        }
        catch (err) {
            console.log(err)
        }

    }


    //   **********************************Update Vote*****************************************

    const incrementVoteCount = async (topicId, topicName) => {
        const existuser = exstingVoteOfUser();
        if (existuser) {
            setAlertText("You have already Submitted your vote!!!you can't give more than one vote")
            setAlertType("warning")
            setShowAlert(true)
        }
        else {
            try {
                setUser((old) => ({ ...old, topicId: topicId, topicName: topicName }))
                const topicsCollectionsRef = doc(db, 'Topics', `${topicId}`)
                const newVote = await runTransaction(db, async (transaction) => {
                    const sfDoc = await transaction.get(topicsCollectionsRef);
                    if (!sfDoc.exists()) {
                        throw "Document does not exist!";
                    }
                    const newPop = sfDoc.data().votes + 1;
                    transaction.update(topicsCollectionsRef, { votes: newPop });
                    setAlertText("Your vote is submitted successfully!");
                    setAlertType("success");
                    setShowAlert(true)
                    addUser(user);
                });
                getAllTopicsData();
                getAllUsersData();

            } catch (e) {
                console.error(e);
            }

        }




    }

    // ************************getIpAddressOFUser**************************************
    const getIpAddressOFUser = async () => {
        const url = "https://api64.ipify.org/?format=json"
        const res = (await axios.get(url)).data;
        setUser((old) => ({ ...old, ip: res.ip }))
    }


    // ************************************AddData Of User*********************************

    const addUser = async (payload) => {
        const docRef = await addDoc(collection(db, "Users"), payload);
        // console.log("Document written with ID: ", docRef.id);
    }

    // *****************************Get All Users Data***************************************
    const getAllUsersData = async () => {
        try {
            const data = await getDocs(usersCollectionRef);
            const getData = data.docs.map((doc) => ({
                ...doc.data(),
                id: doc.id,
            }))

            setUsersData(getData)

        }
        catch (err) {
            console.log(err)
        }

    }

    // ***************************Find Existing User*****************************************
    const exstingVoteOfUser = () => {
        const existVote = usersData?.find((curruser) => {
            return curruser?.ip === user.ip;
        });

        return existVote;

    }

    // ***********************************ADD Topic Data*************************************

    const addTpoic = async (payload) => {
        try {
            const docRef = await addDoc(collection(db, "Topics"), payload);
            setAlertText("Topic data is Added!");
            setAlertType("success");
            setShowAlert(true)
        }catch (err) {
            setAlertText(`Error:${err}`)
            setAlertType("danger")
            setShowAlert(true)
        }

    }


    return (
        <FirebaseContext.Provider value={{
            name, topics, logout, incrementVoteCount,
            showAlert, alertText, alertType, setShowAlert,
            addTpoic, getAllTopicsData
        }}>
            {children}
        </FirebaseContext.Provider>
    )
}

const useFirebaseDataContext = () => {
    return useContext(FirebaseContext)
}
export { FirebaseContext, FirebaseAppProvider, useFirebaseDataContext }